var _path, _ellipse, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _ellipse2, _path3, _ellipse3, _path4, _ellipse4, _path5, _ellipse5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMissingDetailsNinoImage = function SvgMissingDetailsNinoImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 336,
    height: 74,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M.039.719h335v73h-335z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 144.946,
    cy: 20.19,
    fill: "#92DE63",
    rx: 19.534,
    ry: 19.467,
    transform: "rotate(180 144.946 20.19)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#169B62",
    d: "M179.129 73.719c0-18.815-15.305-34.067-34.185-34.067s-34.185 15.252-34.185 34.067z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52.805,
    height: 69.867,
    x: 170.953,
    y: 3.852,
    fill: "#848484",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31.162,
    height: 3.005,
    x: 189.039,
    y: 13.656,
    fill: "#fff",
    rx: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 31.162,
    height: 3.005,
    x: 189.039,
    y: 29.648,
    fill: "#fff",
    rx: 0.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 31.162,
    height: 3.005,
    x: 189.039,
    y: 45.461,
    fill: "#fff",
    rx: 0.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 31.162,
    height: 3.005,
    x: 189.039,
    y: 61.352,
    fill: "#fff",
    rx: 0.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.429,
    cy: 15.059,
    fill: "#169B62",
    rx: 5.335,
    ry: 5.316
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m183.876 13.35-4.595 4.58-2.301-2.293 1.159-1.155 1.142 1.138 3.436-3.425z",
    clipRule: "evenodd"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.429,
    cy: 30.949,
    fill: "#FAFAFA",
    rx: 5.335,
    ry: 5.316
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    fillRule: "evenodd",
    d: "m183.876 29.24-4.595 4.58-2.301-2.292 1.159-1.155 1.142 1.137 3.436-3.424z",
    clipRule: "evenodd"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.429,
    cy: 46.848,
    fill: "#FAFAFA",
    rx: 5.335,
    ry: 5.316
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    fillRule: "evenodd",
    d: "m183.876 45.14-4.595 4.578-2.301-2.292 1.159-1.155 1.142 1.138 3.436-3.425z",
    clipRule: "evenodd"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.429,
    cy: 62.738,
    fill: "#FAFAFA",
    rx: 5.335,
    ry: 5.316
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#848484",
    fillRule: "evenodd",
    d: "m183.876 61.03-4.595 4.58-2.301-2.293 1.159-1.155 1.142 1.137 3.436-3.424z",
    clipRule: "evenodd"
  })));
};
export { SvgMissingDetailsNinoImage as ReactComponent };
export default __webpack_public_path__ + "images/Missing_details_nino_image.svg";